<div>
  <ems-table-record-count class="tbl-rec-count" [count]="totalClients" [showRecords]="totalClients && totalClients > getSharedConstant.defaultTableRecords"
                          (emitter)="pageObject.pageNo = 1;pageObject.pageSize = $event;setPaginationVal(); sharedService.clearSuccessMsgs(this.messageService, true);"
                          [showHeaderIcons]="true"></ems-table-record-count>
  <form [formGroup]="clientsForGlobalRule">
    <p-table [columns]="clientSelectionTableHeader" [value]="clientList" metaKeySelection="true" sortMode="multiple"
             [lazy]="true" (onLazyLoad)="customSort($event)" [customSort]="true" [(selection)]="selectedOrgIDArr" dataKey="subAcctNum"
             (selectionChange)="onSelectionChange()"
             (onRowSelect)="onRowSelect($event)"
             (onRowUnselect)="onRowUnselect($event)"
             [selectionPageonly]="false"
             selectionMode="multiple"
             (onHeaderCheckboxToggle)="onSelectAll($event)"
             [multiSortMeta]="multiSortMeta" class="common-data-table manage-client-list-table" id="client-selection-table-component">
             <ng-template #sorticon pTemplate="sorticon" let-sortOrder>
              <span class="pi" [ngClass]="{
                                    'pi-sort': sortOrder === 0,
                                    'pi-caret-down': sortOrder === 1,
                                    'pi-caret-up': sortOrder === -1,
                                  }"></span>
          </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr class="filter-header-input">
          <th class="table-checkbox-selection filter-icon" aria-label="Toggle filters">
            <span class="sr-only">Toggle filters</span>
            <button type="button" class="btn-icon-only cursor" (click)="toggleFunction()" aria-label="Toggle filter" [attr.aria-expanded]="toggle">
              <em class="pi pi-filter" aria-hidden="true"></em>
            </button>
          </th>
          <th class="table-checkbox-selection" aria-label="Selection">
            <span class="sr-only">Selection</span>
            <p-tableHeaderCheckbox class="emtr-checkbox" *ngIf="enableParentCheckbox" [ariaLabel]="'Select all clients'"></p-tableHeaderCheckbox>
          </th>
          <th *ngFor="let col of columns" [pSortableColumn]="(col.field !== 'masterAccount') && (col.field !== 'subAcctNum')?col.field:''"
              [pSortableColumnDisabled]="(col.field === 'masterAccount' || col.field === 'subAcctNum')"
              [ngClass]="[(totalClients && totalClients > 1) ? 'pointer-events-auto' : 'pointer-events-none', (col.field === 'clientName' || col.field === 'firstName') ? 'w-40-per' : '']">
            {{col.header}}
            <p-sortIcon [field]="col.field" *ngIf="col.field !== 'masterAccount' && col.field !== 'subAcctNum' && (totalClients && totalClients > 1)"></p-sortIcon>
          </th>
        </tr>
        <tr *ngIf="this.toggle" class="filtered-row-input">
          <th aria-label="Filter row"><span class="sr-only">Filter row</span></th>
          <th aria-label="Selection"><span class="sr-only">Selection</span></th>
          <th *ngFor="let col of columns" class="sdps-p-left_small" [attr.aria-label]="(col.header || 'Column') + ' filter'">
            <label class="sr-only" [for]="'client_' + col.field + '_filter'" *ngIf="col.field === 'masterAccount' || col.field === 'subAcctNum'">{{(col.header || 'Master Account') + ' filter'}}</label>
            <input [id]="'client_' + col.field + '_filter'" pInputText [attr.aria-label]="(col.header || 'Master Account') + ' filter'" formControlName="masterAccount" class="w-100-per" type="text" name="filter"
                   (keydown.enter)="!(filterBtnDisable) ? applyFilter() : ''" onkeydown="return (event.keyCode !== 13);"
                   onkeypress="return (event.which >= 48 && event.which <= 57)" *ngIf="col.field === 'masterAccount' || col.field === 'subAcctNum'"
                   [ngClass]="{'invalidField': (clientsForGlobalRule.get('masterAccount').value && filterBtnDisable)}"
                   [maxLength]="8">
          </th>
          <th class="sdps-p-right_none" aria-label="Filter actions">
            <span class="sr-only">Filter actions</span>
            <button class="buttons button-filter"
                    [innerHTML]="emtrConstant.ruleFilter.clearButton" [disabled]="!clientsForGlobalRule.dirty && !isSortingChanged"
                    (click)="clearForm(isSortingChanged)"></button>
            <button class="buttons button-save button-filter" [disabled]="filterBtnDisable"
                    [innerHTML]="emtrConstant.ruleFilter.applyButton" (click)="applyFilter()"></button>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length + 3" class="sdps-text-center sdps-font-weight-bold"
              [innerHTML]="emtrConstant.rulesConstant.autoComplete.noRecords"></td>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
          <td class="table-checkbox-selection filter-icon"></td>
          <td>
            <p-tableCheckbox class="emtr-checkbox"
                             [value]="rowData"
                             [ariaLabel]="'Select client ' + (rowData['clientName'] || rowData['firstName'] || rowData['masterAccount'] || 'row')"></p-tableCheckbox>
          </td>
          <td *ngFor="let col of columns" [ngClass]="col.field === 'firstName' ? 'word-break' : ''">
            <div>
              <span [innerHTML]="rowData[col.field]"></span>
            </div>
          </td>
          <td></td>
        </tr>
      </ng-template>
    </p-table>
  </form>
  <p-paginator class="common-pagination" [alwaysShow]="totalClients && totalClients > getSharedConstant.defaultTableRecords ? true : false" [rows]="pageObject.pageSize" [totalRecords]="totalClients"
               (onPageChange)="paginate($event);" #p></p-paginator>
</div>
